export const isInternetPricingActive = (
    type_of_visualization: string,
    ranking: string
) => type_of_visualization === "ranking" && ranking === "internet_pricing";
